import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowReference } from "../../../common/controls";
import { ShowMultiLine } from "../../../common/controls";
import { ShowReferenceSet } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type AuthorCollectingSocietyViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  collectingSocietyValue: { displayId: string; id: string } | null;
  memberNumberValue?: { displayId: string; id: string } | null;
  memberNumber: string;
  territoriesValues: { displayId: string; id: string }[];
};

export const AuthorCollectingSocietyViewForm: React.FC<AuthorCollectingSocietyViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      collectingSocietyValue,
      memberNumber = "",
      territoriesValues,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupAuthorCollectingSocietyLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowReference
                  label={
                    langStore.AuthorCollectingSocietyCollectingSocietyLabel
                  }
                  selectedValue={langStore.displayIdByLang(
                    collectingSocietyValue?.displayId
                  )}
                />
                <ShowMultiLine
                  value={memberNumber}
                  label={langStore.AuthorCollectingSocietyMemberNumberLabel}
                />
                <ShowReferenceSet
                  label={langStore.AuthorCollectingSocietyTerritoriesLabel}
                  selectedValues={territoriesValues}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
